import React from "react";
export default (props) => {
    const [isExtended, setIsExtended] = React.useState(false);
    const handleMoreInformationClick = () => {
        setIsExtended(!isExtended);
    };
    return (React.createElement("li", { className: `accordion-item ${isExtended ? "is-open" : ""}` },
        React.createElement("button", { className: "accordion-header", onClick: handleMoreInformationClick },
            React.createElement("div", { className: "accordion-header-label" }, props.name),
            React.createElement("div", { className: "accordion-header-icon" },
                React.createElement("i", { className: `no-margin ${isExtended ? "icon-chevron-up" : "icon-chevron-down"}` }))),
        React.createElement("div", { className: "accordion-body" }, props.description)));
};
